import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MessageService } from './message.service';
import { ConfigLoaderService } from '../config/configloader.service';
import { Program } from '../models/program';
import { ProgramTeam } from '../models/programTeam';
import { Project } from '../models/project';


/**
 * this class represents access to all rest requests concerning Project data of the PyWall
 * this rest service honors isMock from settingservice
 */
@Injectable()
export class ProgramService {

  private projectBaseURL: string;

  constructor(
    private http: HttpClient,
    private messageService: MessageService,
    private configService: ConfigLoaderService) {

    const pyWallUrl = this.configService.settings.pyWallServer.url;
    this.projectBaseURL = `${pyWallUrl}programs/`;
  }

  create(data: Program): Observable<Program> {
    this.messageService.sendDebug('ProgramService create called.');
    const targetURL = this.projectBaseURL;
    return this.http.post<Program>(targetURL, data);
  }

  update(programId: number, data: Program): Observable<Program> {
    this.messageService.sendDebug('ProgramService update called.');
    const targetURL = this.projectBaseURL + `${programId}/`;
    return this.http.put<Program>(targetURL, data);
  }

  delete(programId: number): Observable<string> {
    this.messageService.sendDebug('ProgramService delete called.');
    const targetURL = this.projectBaseURL + `${programId}/`;
    return this.http.delete<string>(targetURL);
  }

  getProgramById(programId: number): Observable<Program> {
    this.messageService.sendDebug(`ProgramService getProgramDetails on ${programId} called.`);
    const targetURL = this.projectBaseURL + `${programId}/`;
    return this.http.get<Program>(targetURL);
  }

  getAllPrograms(): Observable<Program[]> {
    this.messageService.sendDebug('ProgramService getAllPrograms called.');
    const targetURL = this.projectBaseURL + '';
    return this.http.get<Program[]>(targetURL);
  }

  addTeamToProgram(programId: number, projectKey: String): Observable<ProgramTeam> {
    this.messageService.sendDebug('ProgramService addTeamToProgram called.');
    const targetURL = this.projectBaseURL + `${programId}/teams`;
    return this.http.post<ProgramTeam>(targetURL, { project_key: projectKey });
  }

  removeTeamFromProgram(programId: number, projectKey: String): Observable<string> {
    this.messageService.sendDebug('ProgramService delete called.');
    const targetURL = this.projectBaseURL + `${programId}/teams/${projectKey}/`;
    return this.http.delete<string>(targetURL);
  }

  getTeamsByProgram(programId: number): Observable<Project[]> {
    this.messageService.sendDebug('ProgramService getTeamsByProgram called.');
    const targetURL = this.projectBaseURL + `${programId}/teams`;
    return this.http.get<Project[]>(targetURL);
  }

  getAllIssuetrackingTypes(): Observable<string[]> {
    this.messageService.sendDebug('ProgramService getAllIssuetrackingTypes called.');
    const pyWallUrl = this.configService.settings.pyWallServer.url;
    const targetURL = `${pyWallUrl}issuetrackingtypes`;
    return this.http.get<string[]>(targetURL);
  }
}
